var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 652,
    height: 171,
    viewBox: "0 0 652 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M50.8029 0.000244141L707.283 105.49C702.887 126.279 696.187 167.293 703.332 170.246C704.115 170.369 704.373 170.426 704.079 170.411C703.815 170.398 703.566 170.342 703.332 170.246C681.953 166.866 269.546 113.303 58.6493 85.9916L50.8029 0.000244141Z",
    fill: "url(#paint0_linear_297_26724)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H52.4501V21.6289H72.9976V81.5971C72.9976 84.9108 70.3113 87.5971 66.9976 87.5971H6C2.68629 87.5971 0 84.9108 0 81.5971V6Z",
    fill: "#D81617"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8279 23.7918L52.4501 0C53.3009 0 54.2225 0.720964 54.577 1.08145C59.6283 6.48868 70.1031 17.6816 71.5919 19.1957C73.0807 20.7097 72.9976 21.4076 72.9976 21.6289L50.8279 23.7918Z",
    fill: "#820002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4501 21.6289V0C53.3009 0 54.2225 0.720964 54.577 1.08145C59.6283 6.48868 70.1031 17.6816 71.5919 19.1957C73.0807 20.7097 72.9976 21.4076 72.9976 21.6289H52.4501Z",
    fill: "#EA615B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.998474 84.7986L50.828 23.7918L72.9976 21.6289V81.5971C72.9976 84.9108 70.3191 87.5971 67.0054 87.5971H12.1663C6.32648 87.5971 2.99847 88.2986 0.998474 84.7986Z",
    fill: "#B80E0F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.3846,
    y: 33.5249,
    width: 35.6877,
    height: 3.24434,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3846,
    y: 45.4207,
    width: 35.6877,
    height: 3.24434,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0206 61.1018C26.0982 61.1018 27.7132 61.5317 28.8658 62.3916C30.0183 63.2514 30.5945 64.5261 30.5945 66.2157C30.5945 67.9806 30.0259 69.3156 28.8885 70.2208C27.7663 71.1108 26.2574 71.5558 24.3618 71.5558H22.6558V76.7828H18.9253V61.1018H24.0206ZM24.0434 68.8857C24.9229 68.8857 25.5902 68.6821 26.0451 68.2748C26.5152 67.8524 26.7503 67.166 26.7503 66.2157C26.7503 64.5714 25.8252 63.7492 23.9751 63.7492H22.6558V68.8857H24.0434Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9548 61.1018C39.4267 61.1018 41.4057 61.66 42.8918 62.7763C44.3931 63.8775 45.1438 65.9064 45.1438 68.8631C45.1438 71.7745 44.4159 73.8261 42.9601 75.0178C41.5043 76.1945 39.6163 76.7828 37.296 76.7828H32.5647V61.1018H36.9548ZM36.2952 63.7945V74.0901H37.5235C38.7519 74.0901 39.6845 73.713 40.3214 72.9587C40.9583 72.1894 41.2768 70.8242 41.2768 68.8631C41.2768 67.5205 41.1176 66.4796 40.7991 65.7405C40.4806 65.0013 40.0484 64.496 39.5025 64.2244C38.9566 63.9378 38.2818 63.7945 37.478 63.7945H36.2952Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3814 76.7828V61.1018H56.7759L56.3892 63.7492H51.1119V67.9127H55.7068V70.5602H51.1119V76.7828H47.3814Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83L40.07 99.97L42.58 92.58L49.97 90.07L33 83Z",
    fill: "white",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93L49 99",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_26724",
    x1: 17,
    y1: 42.5,
    x2: 642.953,
    y2: 144.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B80E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B80E0F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPdf);
export default __webpack_public_path__ + "static/media/DropPdf.6c7638fdf3a63ad3e993a5696ba047b9.svg";
export { ForwardRef as ReactComponent };